// extracted by mini-css-extract-plugin
export default {"title":"yba-z","warning":"zba-z","sizeOptionsLegendText":"Aba-z"};